import { render, staticRenderFns } from "./JsonSummary.vue?vue&type=template&id=18ef11bc&scoped=true&"
import script from "./JsonSummary.vue?vue&type=script&lang=js&"
export * from "./JsonSummary.vue?vue&type=script&lang=js&"
import style0 from "./JsonSummary.vue?vue&type=style&index=0&id=18ef11bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ef11bc",
  null
  
)

export default component.exports